import { createContext } from 'react'

import { PredictionState, initialState } from '@reducers/PredictionReducer'
import { PredictionData } from '@models/Prediction/Prediction'

export interface PredictionContextProps extends PredictionState {
  setCitizenForecasting(forecasting?: PredictionData): void
  setPredictionVeracity(veracity?: boolean): void
  setRectifiedPrediction(rectification?: PredictionData): void
  submitRectification(target: PredictionData): void
  submitForecasting(): void
  submitVoteProbability(): void
  setVoteProbability(probability: number): void
}

export const initialPredictionContext: PredictionContextProps = {
  ...initialState,
  setPredictionVeracity: () => {},
  submitRectification: () => {},
  setCitizenForecasting: () => {},
  setRectifiedPrediction: () => {},
  submitForecasting: () => {},
  submitVoteProbability: () => {},
  setVoteProbability: () => {},
}

export const PredictionContext = createContext<PredictionContextProps>(initialPredictionContext)
